import React, { useState, useContext } from 'react'
import { sortBy, get } from 'lodash'
import { NavLink, useHistory } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FilterInput from '../FilterInput'
import { useStyles } from './styles'
import logo from '../../assets/ojilogo.png'
import { useAuthorization } from '../../services/authorization'
import { GET_WIDGETS_AND_LABS_LIST } from '../../network/lab/queries'
import { GET_USER_ROLES, GET_ACCOUNTS_LIST } from '../../network/auth/queries'
import { LABELS, LINKS } from '../../constants/routes'
import { MENU_PROPS } from '../../constants/theme'
import Can from '../Can'
import { withStyles } from '@material-ui/core/styles'
import { LabContext } from '../../context'

export const NoIconInput = withStyles(() => ({
  root: {
    '& > svg': {
      display: 'none'
    }
  }
}))(FilterInput)

const MainMenu = () => {
  const classes = useStyles()
  const [widgetsList, setWidgetsList] = useState([])
  const {
    labs,
    selectedLab,
    setLabs,
    setSelectedLab,
    setAccounts,
    setSelectedAccount,
    setIsSuperCoordinator,
    accounts,
    selectedAccount,
    isSuperCoordinator
  } = useContext(LabContext)
  const [, , , , userId] = useAuthorization()
  const history = useHistory()
  const { loading: userDataLoading } = useQuery(GET_USER_ROLES, {
    skip: !userId,
    variables: { userId },
    onCompleted: data => {
      const roles = get(data, 'me.profile.roles', [])
      setIsSuperCoordinator(roles.includes('supercoordinator'))
    }
  })

  const { loading: accountsLoading } = useQuery(GET_ACCOUNTS_LIST, {
    skip: !isSuperCoordinator,
    onCompleted: data => {
      const accounts = get(data, 'coordinator.account.list', [])
      setAccounts(accounts)
      setSelectedAccount(accounts[0].id)
    },
    fetchPolicy: 'no-cache'
  })

  const { loading } = useQuery(GET_WIDGETS_AND_LABS_LIST, {
    skip: !userId,
    onCompleted: data => {
      const labs = get(data, 'coordinator.labs.list', [])
      setWidgetsList(data.coordinator.dashboardWidget.list)
      setLabs(labs)
      setSelectedLab(labs[0].id)
    }
  })

  const handleLabChange = lab => {
    setSelectedLab(lab.id)
  }

  const handleAccountChange = account => {
    setSelectedAccount(account.id)
  }

  const goMainPage = () => {
    history.push(LINKS.DASHBOARD)
  }

  return loading || userDataLoading || accountsLoading || !widgetsList.length ? null : (
    <div className={classes.appMenu}>
      <div className={classes.logoBlock} onClick={goMainPage}>
        <img src={logo} alt='logo' />
      </div>
      <Divider classes={{ root: classes.divider }} />
      <div className={classes.labSelector}>
        {isSuperCoordinator && (
          <Select MenuProps={MENU_PROPS} value={selectedAccount} onChange={null} input={<FilterInput />} className={classes.nonDefault}>
            {sortBy(accounts, 'name').map(item => {
              return (
                <MenuItem key={item.id} onClick={() => handleAccountChange(item)} value={item.id} className={classes.menuItem}>
                  {item.name}
                </MenuItem>
              )
            })}
          </Select>
        )}
        {isSuperCoordinator && <div className={classes.divider} />}
        <Select
          MenuProps={MENU_PROPS}
          value={selectedLab}
          onChange={null}
          input={labs.length === 1 ? <NoIconInput /> : <FilterInput />}
          className={classes.nonDefault}
        >
          {sortBy(labs, 'name').map(item => {
            return (
              <MenuItem key={item.id} onClick={() => handleLabChange(item)} value={item.id} className={classes.menuItem}>
                {item.name}
              </MenuItem>
            )
          })}
        </Select>
      </div>
      <Divider classes={{ root: classes.divider }} />
      <div className={classes.menuBlock}>
        <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.DASHBOARD}>
          <Typography variant='h4' component='div'>
            {LABELS.DASHBOARD}
          </Typography>
        </NavLink>
      </div>
      <Divider classes={{ root: classes.divider }} />
      <div className={classes.menuBlock}>
        <Typography variant='h6' component='div' className={classes.subHeading}>
          {LABELS.LEARNERS}
        </Typography>
        <Can list={widgetsList} permission='progress'>
          <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.PROGRESS}>
            <Typography variant='h4' component='div'>
              {LABELS.PROGRESS}
            </Typography>
          </NavLink>
        </Can>
        <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.MANAGEMENT}>
          <Typography variant='h4' component='div'>
            {LABELS.MANAGEMENT}
          </Typography>
        </NavLink>
      </div>
      <Divider classes={{ root: classes.divider }} />
      <div className={classes.menuBlock}>
        <Typography variant='h6' component='div' className={classes.subHeading}>
          {LABELS.IMPACT}
        </Typography>
        <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.STORIES_OVERVIEW}>
          <Typography variant='h4' component='div'>
            {LABELS.STORIES_OVERVIEW}
          </Typography>
        </NavLink>
        <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.STORY_REVIEW}>
          <Typography variant='h4' component='div'>
            {LABELS.STORY_REVIEW}
          </Typography>
        </NavLink>
        {/* <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.ENGAGEMENT}>
          <Typography variant='h4' component='div'>
            {LABELS.ENGAGEMENT}
          </Typography>
        </NavLink> */}
      </div>
      <Divider classes={{ root: classes.divider }} />
      {isSuperCoordinator ? (
        <div className={classes.menuBlock}>
          <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.EVENTS}>
            <Typography variant='h4' component='div'>
              {LABELS.EVENTS}
            </Typography>
          </NavLink>
        </div>
      ) : null}
      <div className={classes.menuBlock}>
        <a target='_blank' rel='noopener noreferrer' className={classes.navLink} href={LINKS.RESOURCE_CENTER}>
          <Typography variant='h4' component='div'>
            {LABELS.RESOURCE_CENTER}
          </Typography>
        </a>
      </div>
      {/* <div className={classes.menuBlock}>
        <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.MOOD_METER}>
          <Typography variant='h4' component='div'>
            {LABELS.MOOD_METER}
          </Typography>
        </NavLink>
      </div>
      <Divider classes={{ root: classes.divider }} /> */}
      <div className={classes.logoutBlock}>
        <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.ACCOUNT_SETTINGS}>
          <Typography variant='h4' component='div'>
            {LABELS.ACCOUNT_SETTINGS}
          </Typography>
        </NavLink>
        <NavLink activeClassName={classes.menuItemSelected} className={classes.navLink} exact to={LINKS.LOGOUT}>
          <Typography variant='h4' component='div'>
            {LABELS.LOGOUT}
          </Typography>
        </NavLink>
      </div>
    </div>
  )
}

export default MainMenu
